import React from 'react';
import { connect } from 'react-redux';
import { I18n } from 'react-redux-i18n';
import { Link } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';

import Pagseguro from '../app/services/pagseguro';
import tagManager from '../app/services/tagManager';
import { getUserCards } from '../app/store/actions/auth';
import { deleteCard } from '../app/store/actions/cards';
import { getCart, setObservation, updateDefaultAddress } from '../app/store/actions/cart';
import { finalizePurchase, getPagSeguroSessionId, savePurchaseFeedback } from '../app/store/actions/purchases';
import CardsUtils from '../app/utils/cards';
import CartUtil from '../app/utils/cart';
import PriceUtils from '../app/utils/price';
import CartResume from '../components/cart/CartResume';
import CheckoutResume from '../components/checkout/CheckoutResume';
import Freight from '../components/checkout/freight/Freight';
import CheckoutPaymentBankSlip from '../components/checkout/payment/CheckoutPaymentBankSlip';
import CheckoutPaymentBilling from '../components/checkout/payment/CheckoutPaymentBilling';
import CheckoutPaymentCard from '../components/checkout/payment/CheckoutPaymentCard';
import CheckoutPaymentCardNew from '../components/checkout/payment/CheckoutPaymentCardNew';
import CheckoutPaymentOnlineDebit from '../components/checkout/payment/CheckoutPaymentOnlineDebit';
import PurchaseFeedback from '../components/purchaseFeedback/purchaseFeedback';
import { history } from '../routers/AppRouter';
import { appendScript, removeScript, scrollToTopAnimated } from '../components/utils';
import InputSize from '../data/inputs';
import ROUTES from '../data/routes';
import NUMBER from '../helpers/number';
import StringHelper from '../helpers/string';

const RctSwal = withReactContent(Swal);
class CheckoutPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      visibleAddress: true, // SOLICITATION -> ADDRESS SERÁ O PRIMEIRO DO CHECKOUT
      visiblePayment: false, // PURCHASE -> PAYMENT SERÁ O PRIMEIRO DO CHECKOUT
      visibleResume: false,
      visibleEnd: false,
      taggedVisiblePayment: false,
      taggedVisibleAddress: false,
      taggedVisibleResume: false,
      payment: {},
      address: {},
      message: '',
      saveCard: false,
      freightShow: '',
      showModal: false,
      location: '',
      payementType: 'credit',
      document: {
        type: 'cpf',
        value: '',
      },
      userData: {
        phone: '',
        birthDate: '',
      },
      feedbackModal: false,
    };
  }

  componentDidMount = () => {
    setTimeout(() => {
      tagManager.onInitCheckout(this.props.cartItems);

      this.initSelectPayementType();

      removeScript('/scripts/panel.min.js');
      appendScript('/scripts/panel.min.js');

      scrollToTopAnimated();

      this.sendTagManagerCheckoutStep(this.props.cartItems);

      this.checkPaymentServiceInit();

      if (this.props.cartId && Object.keys(this.props.deliveryAddress).length > 0) {
        this.setPaymentView();
        this.setDeliveryAddress();
      } else {
        this.setAddressView();
      }
    }, 0);
  }

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
    this.checkPaymentServiceEnd();
  }

  componentDidUpdate = (prevProps, prevStates) => {
    const {
      visiblePayment,
      visibleAddress,
      visibleResume,
      visibleEnd,
    } = this.state;

    this.sendTagManagerCheckoutStep(this.props.cartItems);

    if (
      (prevStates.visiblePayment !== visiblePayment)
      || (prevStates.visibleAddress !== visibleAddress)
      || (prevStates.visibleResume !== visibleResume)
      || (prevStates.visibleEnd !== visibleEnd)
    ) {
      removeScript('/scripts/panel.min.js');
      appendScript('/scripts/panel.min.js');
      scrollToTopAnimated();
    }
  }

  setAddressView = async () => {
    await this.setState({
      visiblePayment: false,
      visibleAddress: true,
    });
  }

  setPaymentView = async () => {
    await this.setState({
      visiblePayment: true,
      visibleAddress: false,
    });
  }

  setDeliveryAddress = async () => {
    await this.setState({ address: this.props.deliveryAddress.address });
  }

  setObservation = (isLocker) => {
    const { observation } = this.props;
    if (isLocker) {
      if (observation.indexOf('Cliente Retira no LOCKER - ') < 0) {
        this.props.setObservation(`Cliente Retira no LOCKER - ${observation}`);
      }
    } else {
      this.props.setObservation(`${observation}`.replace('Cliente Retira no LOCKER - ', ''));
    }
  };

  sendTagManagerCheckoutStep = (cartItems = []) => {
    const {
      visiblePayment,
      taggedVisiblePayment,
      visibleAddress,
      taggedVisibleAddress,
      visibleResume,
      taggedVisibleResume,
    } = this.state;

    if (cartItems.length) {
      if (visibleAddress && !taggedVisiblePayment) {
        tagManager.ecommerceCheckoutSteps(
          cartItems.map(it => it.product || {}),
          2,
          'Delivery',
        );

        this.setState({ taggedVisiblePayment: true });
      } else if (visiblePayment && !taggedVisibleAddress) {
        tagManager.ecommerceCheckoutSteps(
          cartItems.map(it => it.product || {}),
          3,
          'Payment',
        );

        this.setState({ taggedVisibleAddress: true });
      } else if (visibleResume && !taggedVisibleResume) {
        tagManager.ecommerceCheckoutSteps(
          cartItems.map(it => it.product || {}),
          4,
          'Finalize',
        );

        this.setState({ taggedVisibleResume: true });
      }
    }
  }

  checkPaymentServiceInit = async () => {
    const { settings = {} } = this.props;
    const { paymentService = '' } = settings;
    try {
      if (paymentService === 'pagseguro') {
        await Pagseguro.initProcess();
        if (!Pagseguro.hasSessionId()) {
          const sessionId = await this.props.getPagSeguroSessionId();
          if (sessionId) Pagseguro.setSessionId(sessionId);
        }
      }
    } catch (e) {
      // empty
    }

    await this.props.getUserCards();
  }

  checkPaymentServiceEnd = () => {
    const { settings = {} } = this.props;
    const { paymentService = '' } = settings;
    if (paymentService === 'pagseguro') Pagseguro.endProcess();
  }

  setFreight = (location, freight) => {
    this.setAddress({
      nameAbbr: location.nameAbbr,
      cep: location.cep,
      hasTax: location.hasTax,
      freight,
      deliveryCode: location.deliveryCode,
    });
  };

  setFreightCard = (location) => {
    const { freightOn, freightType } = this.props;
    if (freightOn && freightType === 'fob') this.setState({ freightShow: location.cep });
    else this.setFreight(location);
  };

  setPayment = async (type, { card, document } = {}, saveCard = false) => {
    await this.setState({
      payment: { type, card, document }, visiblePayment: false, visibleResume: true, saveCard,
    });
  };

  setData = async ({ phone, birthDate } = {}) => {
    await this.setState({
      userData: { phone, birthDate },
    });
  }

  setAddress = async (address) => {
    const { payment } = this.state;

    await this.setState({
      visibleAddress: false,
      visiblePayment: !payment.type,
      visibleResume: !!payment.type,
      address,
    });
  };

  changeAddress = async () => {
    if (this.props.cartId && this.props.deliveryAddressType) {
      await this.setState({
        visibleAddress: false,
        visibleEnd: false,
        visiblePayment: false,
        visibleResume: false,
        address: {},
        ticket: null,
      });

      history.push(ROUTES.CART);
    } else {
      await this.setState({
        visibleAddress: true,
        visibleEnd: false,
        visiblePayment: false,
        visibleResume: false,
        address: {},
        ticket: null,
      });
    }
  };

  changePayment = async () => {
    const { payment } = this.state;
    delete payment.type;

    await this.setState({
      visibleAddress: false,
      visibleEnd: false,
      visiblePayment: true,
      visibleResume: false,
      payment,
    });
  };

  selectPayementType = async (type) => {
    const { payementType } = this.state;
    const valueType = type === payementType ? '' : type;
    await this.setState({ payementType: valueType });
  }

  initSelectPayementType = () => {
    const {
      pricePermission,
      purchaseCreditPermission,
      purchaseDebitPermission,
      purchaseBankSlipPermission,
      billetOff,
      purchaseBillingPermission,
    } = this.props;

    let valueType = '';

    if (pricePermission && purchaseCreditPermission) {
      valueType = 'credit';
    } else if (pricePermission && purchaseDebitPermission) {
      valueType = 'debit';
    } else if (pricePermission && purchaseBankSlipPermission && !billetOff) {
      valueType = 'bankslip';
    } else if (purchaseBillingPermission) {
      valueType = 'billing';
    }

    this.setState({ payementType: valueType });
  }

  set = async (type) => {
    await this.setState({ payementType: type });
  }

  setDocument = (document) => {
    this.setState({ document });
  }

  finalize = async () => {
    const { address, payment, saveCard } = this.state;

    const {
      cartItems = [], companyTag, taxType, taxFixedValue, settings = {}, userEmail,
    } = this.props;

    const actionField = {};
    const { paymentService = '' } = settings;

    let document;
    if (payment.document) {
      document = {
        ...payment.document,
        value: StringHelper.keepOnlyNumber(payment.document.value),
      };
    }

    try {
      const products = cartItems.map(it => it.product || {});

      const cartProducts = {};
      for (let index = 0; index < cartItems.length; index += 1) {
        const element = cartItems[index].product;
        cartProducts[element.code] = { quantity: element.quantity, valueTotal: element.price.total };
      }

      const paymentInfos = {};
      if (paymentService === 'pagseguro') paymentInfos.paymentService = paymentService;

      try {
        const valueItems = CartUtil.getCartTotal(cartItems, true, undefined, undefined, companyTag);
        const taxes = CartUtil.getCartTax(cartItems, taxType, {
          hasTax: address.hasTax, taxFixedValue,
        }, companyTag);
        actionField.revenue = `${valueItems + taxes}`;
        actionField.affiliation = 'Nortel eShop';
        actionField.tax = `${taxes}`;
      } catch (e) {
        // empty
      }

      const tagManagerOpts = {
        products,
        actionField,
        cartItems,
      };

      const ticket = await this.props.finalize(
        address, payment.type, payment.card,
        document, saveCard, paymentInfos,
        tagManagerOpts, this.state.userData, cartProducts,
      );
      actionField.id = ticket && ticket.id ? `${ticket.id}` : '0';

      if (ticket.redirectUrl) {
        window.location = ticket.redirectUrl;
      } else {
        this.setState({
          visibleEnd: true,
          visibleResume: false,
          payment: {},
          address: {},
          ticket,
        });
      }

      await this.props.setObservation('');
    } catch (err) {
      try {
        const validError = !!(err.response && err.response.data && err.response.data.error);

        if (validError && err.response.data.error.code === 900) {
          this.props.getCart();
          this.setState({
            message: `${I18n.t('cartChanged')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1618) {
          this.setState({
            message: `${I18n.t('purchaseClosedForPayment')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1619) {
          this.setState({
            message: `${I18n.t('purchaseInterruptedForPayment')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 907) {
          this.setState({
            message: `${I18n.t('noLimit')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1003) {
          this.setState({
            message: `${I18n.t('spotItemsError')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && [503, 903, 909].includes(err.response.data.error.code)) {
          this.setState({
            message: `${I18n.t('errorPurchaseContact')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 904) {
          this.setState({
            message: `${I18n.t('errorInvalidDoc')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 902) {
          let minimumPurchase = this.props.minimumPrice || 1.00;
          minimumPurchase = PriceUtils.getPriceText(minimumPurchase, true, this.props.settings.language);
          this.setState({
            message: `${I18n.t('errorMinimumPrice').replace('{?}', minimumPurchase)} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 905) {
          this.setState({
            message: `${I18n.t('errorInvalidCard')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 910) {
          this.setState({
            message: `${I18n.t('errorNotFoundDoc')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 911) {
          this.setState({
            message: `${I18n.t('phoneError')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 912) {
          this.setState({
            message: `${I18n.t('birthError')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 913) {
          this.setState({
            message: `${I18n.t('phoneError2')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 914) {
          this.setState({
            message: `${I18n.t('birthError2')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 915) {
          this.setState({
            message: `${I18n.t('duplicatedCartItems')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 906) {
          this.setState({
            message: `${I18n.t('errorLocation')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 500) {
          this.setState({
            message: `${I18n.t('errorLocationOrClient')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 101) {
          this.setState({
            message: `${I18n.t('errorForbidden')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1004) {
          const sizeObs = this.props.settings && this.props.settings.companyTag === 'nortel'
            ? InputSize.observationNortel.max : InputSize.observation.max;
          this.setState({
            message: `${I18n.t('errorMaxObservation').replace('{?}', sizeObs)} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 504) {
          this.setState({
            message: `${I18n.t('errorGkoClientNotFound')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 107) {
          const detailB = err.response.data.error.details ? err.response.data.error.details : '';
          this.setState({
            message: `Erro Braspag - (${detailB || ''})`,
          });
        } else if (validError && err.response.data.error.code === 1320) {
          this.state({
            message: `${I18n.t('invalidMinimumBillingDate')} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1321) {
          let labelDesc = I18n.t('errorMinimumBillingDate');

          if (this.props.purchaseCreditMinDeliveryDatePermission) labelDesc += `, ${I18n.t('credit').toUpperCase()}`;
          if (this.props.purchaseBankSlipMinDeliveryDatePermission) labelDesc += `, ${I18n.t('bankSlip').toUpperCase()}`;
          this.state({
            message: `${labelDesc} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1322) {
          let labelDesc = I18n.t('errorMinimumBillingDate');

          if (this.props.purchaseCreditMinDeliveryDatePermission) labelDesc += `, ${I18n.t('credit').toUpperCase()}`;
          if (this.props.purchaseBankSlipMinDeliveryDatePermission) labelDesc += `, ${I18n.t('bankSlip').toUpperCase()}`;
          this.state({
            message: `${labelDesc} (CODE: ${err.response.data.error.code})`,
          });
        } else if (validError && err.response.data.error.code === 1614) {
          RctSwal.fire({
            icon: 'error',
            titleText: I18n.t('attention'),
            html: `
              <div style="text-align: justify">
                <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
                <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
              </ >
            `,
          });
        } else if (validError && err.response.data.error.code === 1615) {
          RctSwal.fire({
            icon: 'error',
            titleText: I18n.t('attention'),
            html: `
              <div style="text-align: justify">
                <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
                <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
              </ >
            `,
          });
        } else if (validError && err.response.data.error.code === 1620) {
          await this.setState({
            message: I18n.t('productsWrongPrince', { 0: err.response.data.error.details }),
          });
        } else if (validError && err.response.data.error.code === 1621) {
          await this.setState({
            message: I18n.t('divergenceInProducts'),
          });
        } else {
          const details = validError && err.response.data.error.details;
          const messageErrorSec = err && err.message;

          if (!validError && messageErrorSec) {
            this.setState({
              message: messageErrorSec,
            });
          } else {
            this.setState({
              message: I18n.t('errorTryLater') + (details ? ` (${details})` : ''),
            });
          }
        }
      } catch (e) {
        const validError = err.response && err.response.data && err.response.data.error;
        this.setState({
          message: I18n.t('errorTryLater') + (validError ? ` (CODE: ${err.response.data.error.code})` : ''),
        });
      }
    }
  };

  renderAddress = ({
    address,
    isDefault,
    handleCardClick,
    freightShow,
    setFreight,
    isWithdraw,
    isLocker,
    idx = 0,
  }) => (
    <React.Fragment key={`${idx}`}>
      <div
        className={`basket-delivery ${isDefault ? 'active' : ''} cursorPointer`}
        role="presentation"
        onClick={() => handleCardClick()}
      >
        <div className="ico">
          {(isWithdraw || isLocker) ? (
            <svg className="icon icon-fazer-compras"><use xlinkHref="#icon-fazer-compras" /></svg>
          ) : (
            <svg className="icon icon-caminhao"><use xlinkHref="#icon-caminhao" /></svg>
          )}
        </div>
        <div className="txt">
          <span className="txt-title">
            {
              // eslint-disable-next-line no-nested-ternary
              I18n.t(isWithdraw
                ? 'storeTake'
                : (isLocker)
                  ? 'pickUpAtLockerStore'
                  : 'normalDelivery')
            }
          </span>
          {(isWithdraw || isLocker) ? address.name : address.nameAbbr}
          {' '}
          <br />
          {address.address}
          {' '}
          <br />
          {address.province}
          {' '}
          <br />
          {`${address.city} - ${address.state}`}
          <br />
          {`${NUMBER.cepMask(address.cep)} - ${address.country}`}
        </div>
      </div>
      {freightShow === address.cep && (
        <Freight location={address} setFreight={setFreight} />
      )}
    </React.Fragment>
  )

  renderDeliveryType = ({
    cartItems,
    companyTag,
    visibleEnd,
    locations,
    clientLocation,
    clientWithdraw,
    defaultAddress,
    freightShow,
  }) => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <h1 className="panel-title">{I18n.t('checkoutDeliveryHeader')}</h1>

          <div className="panel-content">

            <div className="box-content">

              <div className="basket">

                <span className="basket-title"><span>{I18n.t('checkoutDeliverySubHeader')}</span></span>

                {defaultAddress && this.renderAddress({
                  address: defaultAddress,
                  isDefault: true,
                  handleCardClick: () => this.setFreightCard(defaultAddress),
                  freightShow,
                  setFreight: this.setFreight,
                  idx: 999,
                })}
                {locations.map((location, index) => {
                  if (!defaultAddress || location.cep !== defaultAddress.cep) {
                    return this.renderAddress({
                      address: location,
                      handleCardClick: () => {
                        // if (locations.length > 1) {
                        //   this.setState({
                        //     showModal: true,
                        //     location,
                        //   });
                        // } else {
                        this.setFreightCard(location);
                        this.setObservation(false);
                        // }
                      },
                      freightShow,
                      setFreight: this.setFreight,
                      idx: index,
                    });
                  }
                  return null;
                })}

                {clientLocation && clientWithdraw && (
                  <React.Fragment>
                    <span className="line" />
                    {this.renderAddress({
                      address: clientLocation,
                      isWithdraw: true,
                      handleCardClick: () => {
                        this.setObservation(false);
                        this.setAddress({ isClient: true });
                      },
                      idx: 998,
                    })}
                    <span className="line" />
                    {this.renderAddress({
                      address: clientLocation,
                      isLocker: true,
                      handleCardClick: () => {
                        this.setObservation(true);
                        this.setAddress({ isLocker: true });
                      },
                      idx: 997,
                    })}
                  </React.Fragment>
                )}

              </div>

            </div>
            {!visibleEnd && (
              <CartResume
                hasItems={cartItems.length > 0}
                subTotal={CartUtil.getCartTotal(cartItems, true, undefined, undefined, companyTag)}
                st={CartUtil.getCartSt(cartItems, companyTag)}
                isCheckout
              />
            )}
          </div>

        </div>
      </div>

    </main>
  )

  renderPaymentCards = ({
    values,
    type,
    document,
    cards = [],
    setDocument,
    setPayment,
    installmentsTotal,
  }) => (
    <React.Fragment>
      {cards.map(card => (
        <CheckoutPaymentCard
          key={card.id}
          card={card}
          type={type}
          personalData={this.state.userData}
          installmentsTotal={installmentsTotal}
          setPayment={setPayment}
          deleteCard={this.props.deleteCard}
          paymentService={this.props.settings.paymentService || ''}
          setData={this.setData}
        />
      ))}

      <CheckoutPaymentCardNew
        values={values}
        type={type}
        installmentsTotal={installmentsTotal}
        setPayment={setPayment}
        document={document}
        personalData={this.state.userData}
        setDocument={setDocument}
        paymentService={this.props.settings.paymentService || ''}
        setData={this.setData}
      />
    </React.Fragment>
  )

  renderPaymentType = ({
    cartItems,
    companyTag,
    valueTotal,
    visibleEnd,
    payment,
    cards = [],
    selectedContract,
    purchaseCreditPermission,
    purchaseDebitPermission,
    purchaseBankSlipPermission,
    purchaseBillingPermission,
    billetOff,
    payementType,
    document,
    pricePermission,
    paymentService,
    address,
    hasPurchaseCreditStockPermission,
    hasPurchaseBankSlipStockPermission,
  }) => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <h1 className="panel-title">{I18n.t('payment')}</h1>

          <div className="panel-content">

            <div className="box-content">

              <div className="basket">
                {pricePermission && (purchaseCreditPermission || purchaseDebitPermission) && (
                  <React.Fragment>
                    {purchaseCreditPermission && (
                      <div
                        className={payementType === 'credit' ? 'basket-card active' : 'basket-card'}
                        style={{
                          MozBorderRadius: '6px',
                          borderRadius: '6px',
                          boxShadow: 'unset',
                        }}
                      >
                        <div
                          className="card checkout-payment-card"
                          onClick={() => this.selectPayementType('credit')}
                          role="presentation"
                        >
                          <span>{I18n.t('credit')}</span>
                          {payementType === 'credit'
                            ? (<div className="checkout-payment-card-arrow-up" />)
                            : (<div className="checkout-payment-card-arrow" />)
                          }
                        </div>
                        <div style={payementType === 'credit' ? undefined : { display: 'none' }}>
                          {
                            hasPurchaseCreditStockPermission ? (
                              this.renderPaymentCards({
                                values: payment.type === 'credit' && payment.card,
                                type: 'credit',
                                document,
                                cards: cards.filter(card => card.type === 'credit'),
                                setDocument: this.setDocument,
                                setPayment: this.setPayment,
                                installmentsTotal: CardsUtils.getInstallmentsTotal(
                                  Number(this.props.maximumPayemntInstallmentTimes),
                                  Number(this.props.minimumPayemntInstallmentValue),
                                  valueTotal,
                                ),
                              })
                            ) : (
                              <p className="error-msg">
                                {I18n.t('invalidItemsCart')}
                              </p>
                            )
                          }
                        </div>
                      </div>
                    )}

                    {purchaseDebitPermission && (
                      <div
                        className={payementType === 'debit' ? 'basket-card active' : 'basket-card'}
                        style={{
                          MozBorderRadius: '6px',
                          borderRadius: '6px',
                          boxShadow: 'unset',
                        }}
                      >
                        <div
                          className="card checkout-payment-card"
                          onClick={() => this.selectPayementType('debit')}
                          role="presentation"
                        >
                          <span>{paymentService === 'pagseguro' ? I18n.t('debitOn') : I18n.t('debit')}</span>
                          {payementType === 'debit'
                            ? (<div className="checkout-payment-card-arrow-up" />)
                            : (<div className="checkout-payment-card-arrow" />)
                          }
                        </div>

                        <div style={payementType === 'debit' ? undefined : { display: 'none' }}>
                          {paymentService === 'pagseguro' ? (
                            <CheckoutPaymentOnlineDebit
                              payementType={payementType}
                              document={document}
                              personalData={this.state.userData}
                              selectPayementType={this.selectPayementType}
                              setDocument={this.setDocument}
                              setPayment={this.setPayment}
                              paymentService={this.props.settings.paymentService || ''}
                              setData={this.setData}
                            />
                          ) : (
                            this.renderPaymentCards({
                              values: payment.type === 'debit' && payment.card,
                              type: 'debit',
                              document,
                              cards: cards.filter(card => card.type === 'debit'),
                              setDocument: this.setDocument,
                              setPayment: this.setPayment,
                              installmentsTotal: CardsUtils.getInstallmentsTotal(
                                Number(this.props.maximumPayemntInstallmentTimes),
                                Number(this.props.minimumPayemntInstallmentValue),
                                valueTotal,
                              ),
                            })
                          )}
                        </div>
                      </div>
                    )}
                  </React.Fragment>
                )}

                {pricePermission && purchaseBankSlipPermission && !billetOff && (
                  <div
                    className={payementType === 'bankslip' ? 'basket-card active' : 'basket-card'}
                    style={{
                      MozBorderRadius: '6px',
                      borderRadius: '6px',
                      boxShadow: 'unset',
                    }}
                  >
                    <div
                      className="card checkout-payment-card"
                      onClick={() => this.selectPayementType('bankslip')}
                      role="presentation"
                    >
                      <span>{I18n.t('bankSlip')}</span>
                      {payementType === 'bankslip'
                        ? (<div className="checkout-payment-card-arrow-up" />)
                        : (<div className="checkout-payment-card-arrow" />)
                      }
                    </div>

                    <div style={payementType === 'bankslip' ? undefined : { display: 'none' }}>
                      {
                        hasPurchaseBankSlipStockPermission ? (
                          <CheckoutPaymentBankSlip
                            payementType={payementType}
                            document={document}
                            personalData={this.state.userData}
                            selectPayementType={this.selectPayementType}
                            setDocument={this.setDocument}
                            setPayment={this.setPayment}
                            setDice={this.props.selectedContract.client.cpf || this.props.selectedContract.client.cnpj}
                            paymentService={this.props.settings.paymentService || ''}
                            setData={this.setData}
                          />
                        ) : (
                          <p className="error-msg">
                            {I18n.t('invalidItemsCart')}
                          </p>
                        )
                      }
                    </div>
                  </div>
                )}

                {purchaseBillingPermission && (
                  <div
                    className={payementType === 'billing' ? 'basket-card active' : 'basket-card'}
                    style={{
                      MozBorderRadius: '6px',
                      borderRadius: '6px',
                      boxShadow: 'unset',
                    }}
                  >
                    <div
                      className="card checkout-payment-card"
                      onClick={() => this.selectPayementType('billing')}
                      role="presentation"
                    >
                      <span>{I18n.t('billing')}</span>
                      {payementType === 'billing'
                        ? (<div className="checkout-payment-card-arrow-up" />)
                        : (<div className="checkout-payment-card-arrow" />)
                      }
                    </div>

                    <div style={payementType === 'billing' ? undefined : { display: 'none' }}>
                      <CheckoutPaymentBilling
                        payementType={payementType}
                        personalData={this.state.userData}
                        selectPayementType={this.selectPayementType}
                        setPayment={this.setPayment}
                        selectedContract={selectedContract}
                        paymentService={this.props.settings.paymentService || ''}
                        setData={this.setData}
                      />
                    </div>
                  </div>
                )}
              </div>
            </div>
            {!visibleEnd && (
              <CartResume
                hasItems={cartItems.length > 0}
                subTotal={CartUtil.getCartTotal(cartItems, true, undefined, undefined, companyTag)}
                st={CartUtil.getCartSt(cartItems, companyTag)}
                isCheckout
                isLocker={address.isLocker || false}
              />
            )}

          </div>

        </div>
      </div>

    </main>
  )

  closeFeedbackModal = async (feedbackData) => {
    await this.props.setFeedback(feedbackData || null);
    await this.setState({ feedbackModal: false });
    await this.finalize();
  }

  renderCheckoutResume = ({
    address,
    payment,
    cartItems,
    changeAddress,
    changePayment,
    visibleResume,
    message,
    pricePermission,
    minimumPrice,
    valueTotal,
    feedbackModal,
  }) => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <h1 className="panel-title">{I18n.t('summary')}</h1>
          <div className="panel-content">
            <CheckoutResume
              address={address}
              payment={payment}
              cartItems={cartItems}
              changeAddress={changeAddress}
              changePayment={changePayment}
              visibleResume={visibleResume}
            />
            <div style={{ width: '100%', textAlign: 'center', margin: '0 auto 40px' }}>
              <p className="error-msg" style={{ marginBottom: message ? 20 : 0 }}>{message}</p>
              {(visibleResume && !pricePermission) || minimumPrice <= valueTotal ? (
                <button
                  type="button"
                  className="btn btn-large"
                  onClick={() => this.showFeedbackModal()}
                >
                  {(payment.type === 'bank_slip') ? I18n.t('checkoutGenerateTicket') : I18n.t('finalizeOrder')}
                </button>
              ) : (
                <p style={{ fontWeight: 600 }}>
                  {I18n.t('minimumPayment')}
                  {' '}
                  {minimumPrice}
                  {' '}
                  {I18n.t('minimumPayment2')}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
      {feedbackModal && (
        <PurchaseFeedback closePurchaseFeedback={feedbackData => this.closeFeedbackModal(feedbackData)} />
      )}
    </main>
  )

  renderCheckoutFinalize = (ticket = {}) => (
    <main>
      <div className="section section-panel">
        <div className="container">
          <div className="box-content">
            <div className="basket cart-status">
              <span className="cart-status-image" style={{ backgroundImage: 'url(/images/check.svg)' }} />
              <p>{(ticket.paymentBankSlipUrl) ? I18n.t('successBuyBillet') : I18n.t('successBuy') }</p>
              {ticket.paymentBankSlipUrl
                && (
                <div
                  className="cursorPointer"
                  onClick={() => window.open(ticket.paymentBankSlipUrl, '_blank', 'width=500,height=500')}
                  role="presentation"
                >
                  <span
                    className="checkout-image-bar"
                    style={{ backgroundImage: 'url(/images/codigo-de-barras.svg)' }}
                  />
                  <p style={{ fontSize: 'small' }}>{I18n.t('bankSlipVisualize')}</p>
                  <br />
                  <p style={{ fontSize: 'small' }}>{I18n.t('billetWarningMessage')}</p>
                </div>
                )}
              {ticket.paymentOnlineDebitUrl
                && (
                  <React.Fragment>
                    <br />
                    <button
                      type="button"
                      className="btn"
                      onClick={
                        () => window.open(ticket.paymentOnlineDebitUrl, '_blank', 'width=500,height=500')
                      }
                    >
                      {I18n.t('debitOn')}
                    </button>
                  </React.Fragment>
                )}
              <br />
              <br />
              <Link to={ROUTES.ORDER_LIST} className="btn">
                {I18n.t('details')}
              </Link>
            </div>
          </div>
        </div>
      </div>
    </main>
  )

  showFeedbackModal = async () => {
    const {
      cartItems, punchOut, typeOfAccess, userEmail,
    } = this.props;

    if (!!punchOut && typeOfAccess === 'normal') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess1', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else if ((punchOut === null || punchOut === undefined) && typeOfAccess === 'punchout') {
      RctSwal.fire({
        icon: 'error',
        titleText: I18n.t('attention'),
        html: `
          <div style="text-align: justify">
            <p style="margin: 20px 0px">${I18n.t('invalidPunchoutUserAccess2', { 0: userEmail || '' })}</p>
            <p>${I18n.t('invalidPunchoutUserAccess3')}</p>
          </ >
        `,
      });
    } else {
      if (cartItems.length > 0) {
        const products = [];
        for (let index = 0; index < cartItems.length; index += 1) {
          const element = cartItems[index];

          if ((Object.keys(element.product).length > 0) && element.product.quantity && element.product.multipleQuantity) {
            if ((element.product.quantity % parseFloat(element.product.multipleQuantity)) !== 0) {
              products.push(element.product.id);
            }
          }
        }

        if (products.length > 0) {
          this.multipleValidation(products.toString().replace(/,/g, ', '));
          return null;
        }
      }

      await this.setState({ feedbackModal: true });
    }
  }

  multipleValidation = productsCodes => (
    Swal.fire({
      titleText: I18n.t('ProductsInCartWithInvalidMultipleQuantities'),
      text: productsCodes,
      icon: 'warning',
    })
  )

  render() {
    const {
      minimumPrice, cartItems, pricePermission, companyTag,
      locations = [], clientLocation, clientWithdraw, defaultAddress,
      cards,
      selectedContract,
      purchaseCreditPermission,
      purchaseDebitPermission,
      purchaseBankSlipPermission,
      purchaseBillingPermission,
      billetOff,
      settings = {},
      purchaseCreditStockPermission,
      purchaseBankSlipStockPermission,
    } = this.props;

    const { paymentService = '' } = settings;

    const {
      payment, visiblePayment, visibleAddress, address,
      visibleEnd, visibleResume, ticket, message, freightShow,
      payementType, document, feedbackModal,
    } = this.state;

    const valueTotal = cartItems.reduce((total, item) => total + item.product.price.total, 0);
    const hasItemWithoutStock = !!cartItems.filter(item => item.total > (item.product.stock || 0)).length;

    let hasPurchaseCreditStockPermission = true;
    let hasPurchaseBankSlipStockPermission = true;

    if (hasItemWithoutStock) {
      hasPurchaseCreditStockPermission = purchaseCreditStockPermission;
      hasPurchaseBankSlipStockPermission = purchaseBankSlipStockPermission;
    }

    if (!visibleResume) {
      if (visibleAddress) {
        return this.renderDeliveryType({
          cartItems,
          companyTag,
          visibleEnd,
          locations,
          clientLocation,
          clientWithdraw,
          defaultAddress,
          freightShow,
        });
      }
      if (visiblePayment) {
        return this.renderPaymentType({
          cartItems,
          companyTag,
          valueTotal,
          visibleEnd,
          payment,
          cards,
          selectedContract,
          purchaseCreditPermission,
          purchaseDebitPermission,
          purchaseBankSlipPermission,
          purchaseBillingPermission,
          billetOff,
          payementType,
          document,
          pricePermission,
          paymentService,
          address,
          hasPurchaseCreditStockPermission,
          hasPurchaseBankSlipStockPermission,
        });
      }
    }

    if (!visibleEnd) {
      return this.renderCheckoutResume({
        address,
        payment,
        cartItems,
        changeAddress: this.changeAddress,
        changePayment: this.changePayment,
        visibleResume,
        message,
        pricePermission,
        minimumPrice,
        valueTotal,
        feedbackModal,
      });
    }

    if (visibleEnd) return this.renderCheckoutFinalize(ticket);

    return null;
  }
}

const mapStateToProps = state => ({
  cartItems: state.cart.items,
  observation: state.cart.observation,
  companyTag: state.settings.companyTag,
  minimumPrice: state.contracts.selected.clientDetails && state.contracts.selected.clientDetails.minimumPurchase > 0
    ? Number(state.contracts.selected.clientDetails.minimumPurchase)
    : Number(state.settings.minimumPurchase),
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  settings: state.settings,
  parcel: state,
  locations: state.contracts.selected && state.contracts.selected.client
    && state.contracts.selected.client.locations,
  clientLocation: state.contracts.selected && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.location,
  freightOn: state.settings.freightOn,
  freightType: state.contracts && state.contracts.selected.clientDetails.freight,
  clientWithdraw: state.contracts && state.contracts.selected.clientDetails.clientWithdraw,
  defaultAddress: state.contracts && state.contracts.selected && state.contracts.selected.defaultAddress,
  selectedContract: state.contracts.selected,
  payments: state,
  cards: state.cards.list,
  purchaseBankSlipPermission: state.contracts.selected && state.contracts.selected.purchaseBankSlipPermission,
  purchaseBankSlipStockPermission: state.contracts.selected && state.contracts.selected.purchaseBankSlipStockPermission,
  purchaseStockMinDeliveryDatePermission: state.contracts.selected && state.contracts.selected.purchaseStockMinDeliveryDatePermission,
  purchaseBillingPermission: state.contracts.selected && state.contracts.selected.purchaseBillingPermission,
  purchaseCreditPermission: state.contracts.selected && state.contracts.selected.purchaseCreditPermission,
  purchaseCreditStockPermission: state.contracts.selected && state.contracts.selected.purchaseCreditStockPermission,
  purchaseCreditMinDeliveryDatePermission: state.contracts.selected && state.contracts.selected.purchaseCreditMinDeliveryDatePermission,
  purchaseDebitPermission: state.contracts.selected && state.contracts.selected.purchaseDebitPermission,
  minimumBillingDate: state.cart.minimumBillingDate,
  billetOff: state.settings.billetOff,
  maximumPayemntInstallmentTimes: state.settings.maximumPayemntInstallmentTimes,
  minimumPayemntInstallmentValue: state.settings.minimumPayemntInstallmentValue,
  taxType: state.settings && state.settings.taxType,
  taxFixedValue: Number(state.settings && state.settings.taxFixedValue, 0),
  purchaseFeedback: state.purchase && state.purchase.purchaseFeedback,
  cartId: state.cart && state.cart.cartId,
  deliveryAddress: state.cart && state.cart.deliveryAddress,
  deliveryAddressType: state.contracts.selected
    && state.contracts.selected.clientDetails
    && state.contracts.selected.clientDetails.deliveryAddressType,
  punchOut: state.punchOut,
  typeOfAccess: state.auth && state.auth.user && state.auth.user.typeOfAccess,
  userEmail: state.auth && state.auth.user && state.auth.user.email,
});

const mapDispatchToProps = dispatch => ({
  finalize: (
    location, type, card,
    document, saveCard = false, paymentInfos = {},
    tagManagerOpts = {}, userData = {}, cartProducts = {},
  ) => dispatch(
    finalizePurchase(location, type, card, document, saveCard, paymentInfos, tagManagerOpts, userData, cartProducts),
  ),
  getPagSeguroSessionId: () => getPagSeguroSessionId(dispatch),
  getUserCards: () => dispatch(getUserCards()),
  getCart: () => dispatch(getCart()),
  updateDefaultAddress: (cep, nameAbbr) => dispatch(updateDefaultAddress(cep, nameAbbr)),
  deleteCard: card => dispatch(deleteCard(card)),
  setObservation: observationText => dispatch(setObservation(observationText)),
  setFeedback: feedbackData => dispatch(savePurchaseFeedback(feedbackData)),
});

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPage);
